export const toggleVisibility = (elementId) => {
  const elm = document.getElementById(elementId);
  if (elm) elm.style.display = elm.style.display === 'block' ? 'none' : 'block';
};

export const checkCamera = ({ vehicles }) => {
  return vehicles?.vehicleFilteredList?.some(
    (ele) => ele.cameraSerialNo && ele.cameraSerialNo.length > 0
  );
};
